package org.example.zone360.models

data class QuickAction(
    val title: String,
    val query: String,
    val forceReport: Boolean = false
)